import { Flex, Image, Text, Button, FormControl, FormLabel, Input, FormErrorMessage, Box, Stack, Checkbox, Link, InputGroup, InputRightElement, useToast, Card, CardHeader, CardBody, CardFooter, Heading } from "@chakra-ui/react";
import { Field, Form, Formik, FormikErrors } from "formik";
import { useEffect, useState } from "react";

import { login } from "@/services/api/thunks/users";
import { useAppDispatch } from "@/store/hooks";

import WxLogin from "@/components/wxlogin";
import { LoginForm, UserProfile } from "@/types/user";
import { useGetCodeMutation, useRegisterMutation } from "@/services/api/endpoints/users";
import { isPhone } from "@/utils/utils";
import { useLazyWxtokenQuery, useWxsendMutation, useWxsaveMutation } from "@/services/api/endpoints/wxlogin";
import { useNavigate } from "react-router-dom";

import message from "@/assets/message.png";
import message_checked from "@/assets/message_checked.png";

import account from "@/assets/account.png";
import account_checked from "@/assets/account_checked.png";

import wechat from "@/assets/wechat.png";
import wechat_checked from "@/assets/wechat_checked.png";
import { ServerError } from "@/types/errors";

type Props = {
  binding: boolean;
  wxuser?: UserProfile;
  loginBy: number;
  handleLoginBy: (value: number) => void;
  onClose: () => void;
};

const Login = (props: Props) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [btnTxt, setBtnTxt] = useState("发送验证码");
  const [isDisable, setIsDisable] = useState(false);
  const [getCode] = useGetCodeMutation();
  const [wxsend] = useWxsendMutation();
  const [wxsave] = useWxsaveMutation();
  const [register] = useRegisterMutation();
  //控制登录/注册文本
  const [headerTxt, setHeaderTxt] = useState("短信登录");
  const [txt1, setTxt1] = useState("登录");
  const [loading, setLoading] = useState(false);
  // 监听页面地址栏url的改变 获取参数code
  const params = new URLSearchParams(window.location.search);
  const tId = params.get("dstid") ?? ""; //分销员id
  const origin = params.get("origin") ?? ""; //分销渠道
  const location = params.get("location") ?? ""; //分销渠道位置
  const clickId = params.get("clickid") ?? ""; //巨量引擎流量
  const txclickId1 = params.get("gdt_vid") ?? ""; //微信流量
  const txclickId2 = params.get("qz_gdt") ?? ""; //非微信流量

  const toast = useToast();

  const form: LoginForm = {
    id: "",
    login_id: "",
    password: "",
    phone: "",
    code: "",
    union_id: "",
  };
  const handleSubmit = async (values: LoginForm) => {
    if (txt1 === "登录") {
      const result = await dispatch(login(values));
      if (result.type == "users/login/rejected") {
        const error = result.payload as ServerError;
        if (error.id !== "api.user.login.not_found") {
          toast({
            title: error.message,
            position: "top",
            status: "error",
            duration: 2000,
            isClosable: false,
          });
        } else {
          const user = {
            phone: values.phone,
            code: values.code,
            password: "12345678",
            invite_code: params.get("invite_code")!,
            referrer: params.get("referrer")!,
          } as UserProfile;
          const result = await register({ user: user, tId: tId, origin: origin, location: location, ttClickId: clickId, txClickId1: txclickId1, txClickId2: txclickId2 }).unwrap();
          if (result) {
            const loginForm = {
              id: result.id,
              password: user.password,
            } as LoginForm;
            const res = await dispatch(login(loginForm));
            if (res.type === "users/login/fulfilled") {
              props.onClose();
            }
          }
        }
      } else {
        props.onClose();
      }
    }
  };
  const handleGetCode = async (fn: Function, values: LoginForm) => {
    let seconds = 60;
    var interval: any;
    if (isPhone(values.phone)) {
      const res = await getCode({ phone: values.phone }).unwrap();
      if (res.status) {
        interval = setInterval(() => {
          if (seconds-- <= 0) {
            seconds = 60;
            setIsDisable(false);
            setBtnTxt("获取验证码");
            clearInterval(interval);
          } else {
            setIsDisable(true);
            setBtnTxt(seconds + "s后重新获取");
          }
        }, 1000);
      }
    } else {
      fn("phone", true, true);
    }
  };

  const handleGetCode2 = async (fn: Function, values: LoginForm) => {
    let seconds = 60;
    var interval: any;
    if (isPhone(values.phone)) {
      const result = await wxsend({ phone: values.phone }).unwrap();
      if (result.status) {
        interval = setInterval(() => {
          if (seconds-- <= 0) {
            seconds = 60;
            setIsDisable(false);
            setBtnTxt("获取验证码");
            clearInterval(interval);
          } else {
            setIsDisable(true);
            setBtnTxt(seconds + "s后重新获取");
          }
        }, 1000);
      }
    } else {
      fn("phone", true, true);
    }
  };

  const handleValidate1 = (values: { phone: string; code: string }) => {
    const errors: FormikErrors<{ phone: string; code: string }> = {};
    if (!values.phone) {
      errors.phone = "手机号不能为空";
    } else if (!isPhone(values.phone)) {
      errors.phone = "请输入正确的手机号";
    }

    if (!values.code) {
      errors.code = "验证码不能为空";
    }
    return errors;
  };
  const handleValidate3 = (values: { phone: string; code: string }) => {
    const errors: FormikErrors<{ phone: string; code: string }> = {};
    if (!values.phone) {
      errors.phone = "手机号不能为空";
    } else if (!isPhone(values.phone)) {
      errors.phone = "请输入正确的手机号";
    }

    if (!values.code) {
      errors.code = "验证码不能为空";
    }
    return errors;
  };
  const handleValidate2 = (values: { login_id: string; password: string }) => {
    const errors: FormikErrors<{ login_id: string; password: string }> = {};
    if (!values.login_id) {
      errors.login_id = "用户名不能为空";
    }
    if (!values.password) {
      errors.password = "密码不能为空";
    }
    return errors;
  };

  const handleBind = async (values: LoginForm) => {
    var user = {
      phone: values.phone,
      code: values.code,
      openid: props.wxuser?.openid,
      nickname: props.wxuser?.nickname,
      headimgurl: props.wxuser?.headimgurl,
      unionid: props.wxuser?.unionid,
      referrer: params.get("referrer"),
    } as UserProfile;
    const result = await wxsave(user).unwrap();
    if (result.unionid) {
      form.union_id = result.unionid;
      const res = await dispatch(login(form));
      if (res.type == "users/login/fulfilled") {
        props.onClose();
      }
    }
  };

  return (
    <Flex justifyContent={"flex-end"} mr="294px">
      <Stack bgColor="rgba(255, 255, 255, 0.5)" w="440px" mt="100px" align={"center"} pt="44px" pb="60px">
        <Text color="#27314D" fontSize={"24px"}>
          {headerTxt}
        </Text>
        <Text color="#8E94A9" fontSize={"16px"}>
          {props.loginBy == 1 ? "欢迎来到阿拉丁GPT" : "欢迎来到阿拉丁GPT, 新用户将自动注册"}
        </Text>
        {props.loginBy === 0 && (
          <Formik initialValues={form} onSubmit={handleSubmit} validate={handleValidate1}>
            {({ setFieldTouched, values }) => (
              <Form>
                <Field name="phone">
                  {({ field, form }: any) => (
                    <FormControl isInvalid={form.errors.phone && form.touched.phone} mt={"20px"}>
                      <Input {...field} placeholder="请输入手机号" maxLength={11} />
                      <FormErrorMessage>{form.errors.phone}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="code">
                  {({ field, form }: any) => (
                    <FormControl isInvalid={form.errors.code && form.touched.code} mt={"20px"}>
                      <InputGroup size="md">
                        <Input {...field} placeholder="请输入验证码" maxLength={6} />
                        <InputRightElement width="6rem">
                          <Button
                            h="1.5rem"
                            mr="5px"
                            variant="Unstyled"
                            color="blue.500"
                            colorScheme="blue"
                            fontSize="12px"
                            isDisabled={isDisable}
                            onClick={() => {
                              handleGetCode(setFieldTouched, values);
                            }}
                          >
                            {btnTxt}
                          </Button>
                        </InputRightElement>
                      </InputGroup>
                      <FormErrorMessage>{form.errors.code}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Stack mt="50px">
                  <Checkbox defaultChecked fontSize="14px" color="#8E94A9">
                    我已阅读并同意
                    <Link color="blue.500" href="" style={{ textDecoration: "none" }}>
                      《用户协议》
                    </Link>
                    和
                    <Link color="blue.500" href="" style={{ textDecoration: "none" }}>
                      《隐私政策》
                    </Link>
                  </Checkbox>
                  <Button mt="20px" type="submit" colorScheme="blue" isLoading={loading} loadingText="正在登录...">
                    登录
                  </Button>
                </Stack>
              </Form>
            )}
          </Formik>
        )}
        {props.loginBy === 1 && (
          <Formik initialValues={form} onSubmit={handleSubmit} validate={handleValidate2}>
            <Form>
              <Field name="login_id">
                {({ field, form }: any) => (
                  <FormControl isInvalid={form.errors.login_id && form.touched.login_id} mt={"20px"}>
                    <Input {...field} placeholder="请输入用户名" />
                    <FormErrorMessage>{form.errors.login_id}</FormErrorMessage>
                  </FormControl>
                )}
              </Field>
              <Field name="password">
                {({ field, form }: any) => (
                  <FormControl isInvalid={form.errors.password && form.touched.password} mt={"20px"}>
                    <Input {...field} placeholder="请输入密码" type="password" />
                    <FormErrorMessage>{form.errors.password}</FormErrorMessage>
                  </FormControl>
                )}
              </Field>
              <Flex justifyContent={"flex-end"} cursor={"pointer"}>
                <Text variant="Unstyled" color="#8E94A9" fontSize="12px" userSelect="none" mt="2px">
                  忘记密码
                </Text>
              </Flex>
              <Stack mt="30px">
                <Checkbox defaultChecked fontSize="14px" color="#8E94A9">
                  我已阅读并同意
                  <Link color="blue.500" href="#">
                    《用户协议》
                  </Link>
                  和
                  <Link color="blue.500" href="#">
                    《隐私政策》
                  </Link>
                </Checkbox>
                <Button mt="20px" type="submit" colorScheme="blue" isLoading={loading} loadingText="正在登录...">
                  登录
                </Button>
              </Stack>
            </Form>
          </Formik>
        )}
        {props.loginBy === 2 && (
          <Box>
            {props.binding ? (
              <WxLogin />
            ) : (
              <Formik initialValues={form} onSubmit={handleBind} validate={handleValidate3}>
                {({ setFieldTouched, values }) => (
                  <Form>
                    <Field name="phone">
                      {({ field, form }: any) => (
                        <FormControl isInvalid={form.errors.phone && form.touched.phone} mt={"20px"}>
                          <Input {...field} placeholder="请输入手机号" maxLength={11} />
                          <FormErrorMessage>{form.errors.phone}</FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                    <Field name="code">
                      {({ field, form }: any) => (
                        <FormControl isInvalid={form.errors.code && form.touched.code} mt={"20px"}>
                          <InputGroup size="md">
                            <Input {...field} placeholder="请输入验证码" maxLength={6} />
                            <InputRightElement width="6rem">
                              <Button
                                h="1.5rem"
                                mr="5px"
                                variant="Unstyled"
                                color="blue.500"
                                colorScheme="blue"
                                fontSize="12px"
                                isDisabled={isDisable}
                                onClick={() => {
                                  handleGetCode2(setFieldTouched, values);
                                }}
                              >
                                {btnTxt}
                              </Button>
                            </InputRightElement>
                          </InputGroup>
                          <FormErrorMessage>{form.errors.code}</FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                    <Stack mt="50px">
                      <Checkbox defaultChecked fontSize="14px" color="#8E94A9">
                        我已阅读并同意
                        <Link color="blue.500" href="#">
                          《用户协议》
                        </Link>
                        和
                        <Link color="blue.500" href="#">
                          《隐私政策》
                        </Link>
                      </Checkbox>
                      <Button mt="20px" type="submit" colorScheme="blue" isLoading={loading} loadingText="正在登录...">
                        绑定手机号
                      </Button>
                    </Stack>
                  </Form>
                )}
              </Formik>
            )}
          </Box>
        )}
        <Box mt="40px">
          <Text color="#8E94A9" fontSize={"16px"}>
            选择其他登录方式
          </Text>
          <Flex mt="30px">
            <Image
              src={props.loginBy == 0 ? message_checked : message}
              cursor="pointer"
              onClick={() => {
                props.handleLoginBy(0);
                setHeaderTxt("短信登录");
              }}
            />
            <Image
              src={props.loginBy == 1 ? account_checked : account}
              ml="34px"
              mr="34px"
              cursor="pointer"
              onClick={() => {
                props.handleLoginBy(1);
                setHeaderTxt("账号登录");
              }}
            />
            <Image
              src={props.loginBy == 2 ? wechat_checked : wechat}
              cursor="pointer"
              onClick={() => {
                props.handleLoginBy(2);
                setHeaderTxt("微信登录");
              }}
            />
          </Flex>
        </Box>
      </Stack>
    </Flex>
  );
};

export default Login;
